<div class="work-popup modal-dialog">

  <div class="modal-content">
    <form [formGroup]="form" method="post" (ngSubmit)="saveUserCardContent()" class="py-3 px-sm-4">
      <div class="size-fixed width-100 d-flex align-items-center justify-content-center">
        <img [src]="contentIcon" class="content-icon-styles" alt="">
      </div>
      <div class="flex-fill mt-30px">
        @if (!isDocument()) {
          <app-filled-form-field
            formControlName="placeholder"
            [isControlInvalid]="!form.get('placeholder').valid && form.get('placeholder').hasError('pattern') && form.get('placeholder').touched"
                           [errorMessage]="'TelCell ID must be 8 digits'"
            [label]="isShowPhoneNumber() ? contentResponse.name + '(+374xxxxxxxx)' : (isContact() ? contentResponse.name : ('labels_modal.profile_link' | translate))">
          </app-filled-form-field>
        } @else {
          <input
            #documentUploadInput
            hidden
            tabindex="-1"
            (change)="onFileSelected($event)"
            accept="application/pdf"
            type="file"
            class="form-control text-size"
          />
          <label class="document-input-label"
            [class]="!selectedFile && !hasDocumentURL ? 'cursor-pointer' : ''"
            [ngClass]="{'disabled': hasDocumentURL, 'has-error': showError || fileSizeExceeded}">
            <div (click)="clickChooseFile(documentUploadInput)" class="document-choose-file">Choose File</div>
            <div (click)="clickChooseFile(documentUploadInput)" class="document-file-name">{{ documentName }}</div>
            <div class="width-20 d-flex align-items-center justify-content-center">
              @if(selectedFile) {
                <mat-icon class="document-clear-icon" (click)="clearDocument()">close</mat-icon>
              }
            </div>
          </label>
        }

        @if (createUserCardContentControl['placeholder'].invalid && createUserCardContentControl['placeholder'].touched && !isDocument()) {
          <div class="validation" [style.margin-top]="isDocument() ? '' : '-20px'">
            @if (createUserCardContentControl['placeholder'].errors?.['required'] || createUserCardContentControl['placeholder'].errors?.['whitespace']) {
              <small>{{'labels_modal.enter' | translate }}
                <small
                  class="inner-small"
                  [textContent]="isContact() ? contentResponse.name.toLowerCase() :  ('labels_modal.profile_error_message' | translate)"></small>
              </small>
            }
          </div>
        }

        @if (isDocument()) {
          @if (fileSizeExceeded) {
            <div class="validation">
              <small *ngIf="fileSizeExceeded">{{ 'error_messages_user_card.file_size_error' | translate }}</small>
            </div>
          }
        }
      </div>

      @if (isDocument()) {
        <div class="mr-2 mt-2 flex-fill">
           <app-filled-form-field
             formControlName="placeholder"
             [label]="'URL'"
             [errorMessage]="'Please upload a file or provide a link'"
             [isControlInvalid]="showError && isBothDocumentFieldsInvalid()"
           >
           </app-filled-form-field>
        </div>
      }

      <div class="mr-2 mt-2 flex-fill">
        <app-filled-form-field
          formControlName="linkTitle"
          [label]="'labels_modal.link_title' | translate"
          (keydown.enter)="onEnter($event)"
        >
        </app-filled-form-field>

        @if (createUserCardContentControl['linkTitle'].invalid && createUserCardContentControl['linkTitle'].touched) {
          <div class="validation validation-direction">
            @if (createUserCardContentControl['linkTitle'].errors?.['whitespace']) {
              <small>Enter link title</small>
            } @else if (createUserCardContentControl['linkTitle'].errors?.['maxlength'] && createUserCardContentControl['linkTitle'].touched) {
              <small>{{ 'error_messages_user_card.linkTitleError' | translate }}</small>
            }
          </div>
        }
      </div>

      <div class="mt-30px d-flex justify-content-center buttons-style flex-direction-row">
        <button type="submit" [disabled]="form.invalid"
                class="filled-button short-button width-100 mr-10px d-flex align-items-center justify-content-center">
          {{ 'user_card.save' | translate }}
        </button>
        <button type="button"
                class="outlined-button short-button width-100 ml-10px d-flex align-items-center justify-content-center"
                (click)="closeDialog()">
          {{ 'user_card.cancel' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
